import React, { useState, useEffect } from "react";
import { Button, Spinner, Alert, Card, CardBody } from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getMantisBusiness,
  updateBusinessEnabledSections,
} from "../../ApiCalls/backoffice";

const select = (state) => ({
  userId: state.auth.userId,
  token: state.auth.token,
});

const sectionsFriendlyNames = {
  DASHBOARD: "Dashboard",
  USERS: "Usuarios",
  ARCHIVE: "Archivo",
  CONTROL_PANEL: "Panel de control",
  INTEGRATIONS: "Integraciones",
  ASSISTANT: "Chat",
  BUDGET_DASHBOARD: "Dashboard de presupuesto",
  FORMS: "Formularios",
  CONTROL_PANEL_P2O: "Panel de control IPRs",
  REQUISITIONS_DASHBOARD: "Dashboard de requisiciones",
};

function BusinessSectionsTab(props) {
  const [mantisBusiness, setMantisBusiness] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedSections, setSelectedSections] = useState([]);
  const [updating, setUpdating] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const { id } = useParams();

  const sectionsOptions = [
    { value: "DASHBOARD", label: "Dashboard" },
    { value: "ASSISTANT", label: "Chat" },
    { value: "ARCHIVE", label: "Archivo" },
    { value: "CONTROL_PANEL", label: "Panel de control" },
    { value: "USERS", label: "Usuarios" },
    { value: "INTEGRATIONS", label: "Integraciones" },
    { value: "BUDGET_DASHBOARD", label: "Dashboard de presupuesto" },
    { value: "FORMS", label: "Formularios" },
    { value: "CONTROL_PANEL_P2O", label: "Panel de control IPRs" },
    { value: "REQUISITIONS_DASHBOARD", label: "Dashboard de requisiciones" },
  ];

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mantisBusiness) {
      let selected = [];
      mantisBusiness.enabledSections.forEach((section) => {
        selected.push({
          value: section,
          label: sectionsFriendlyNames[section],
        });
      });
      setSelectedSections(selected);
    }
  }, [mantisBusiness]);

  async function loadData() {
    const businessRes = await getMantisBusiness(props.token, props.userId, id);
    if (businessRes.success) {
      setMantisBusiness(businessRes.mantisBusiness);
    }
    setLoading(false);
  }

  async function handleUpdateSections() {
    setUpdating(true);
    const sections = selectedSections.map((s) => s.value);
    const res = await updateBusinessEnabledSections(
      props.userId,
      id,
      sections,
      props.token
    );
    if (res.success) {
      setAlertMessage("Secciones actualizadas correctamente");
    } else {
      setAlertMessage("Error al actualizar las secciones");
    }
    setUpdating(false);
  }

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div>
      {alertMessage && (
        <Alert
          color={alertMessage.includes("Error") ? "danger" : "info"}
          isOpen={alertMessage !== ""}
          toggle={() => setAlertMessage("")}
          className="mb-3"
        >
          {alertMessage}
        </Alert>
      )}

      <Card>
        <CardBody>
          <h3 className="card-title mb-4">
            <i className="fas fa-puzzle-piece"></i> Secciones habilitadas
          </h3>
          <div className="section-selector">
            <Select
              options={sectionsOptions}
              closeMenuOnSelect={false}
              isMulti
              value={selectedSections}
              onChange={setSelectedSections}
              className="custom-select"
              placeholder="Selecciona las secciones..."
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              menuPortalTarget={document.body}
            />
            <Button
              onClick={handleUpdateSections}
              disabled={updating}
              className="update-button mt-3"
              color="primary"
            >
              {updating ? (
                <span className="button-content">
                  <Spinner size="sm" />
                  Actualizando...
                </span>
              ) : (
                <span className="button-content">
                  <i className="fas fa-save"></i> Actualizar secciones
                </span>
              )}
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default connect(select)(BusinessSectionsTab);
